import { fetch } from '@/plugin/axios/index.js'
import formAxios from '@/plugin/axios/formAxios.js'

/**
 * @param {Object} data
 * 获取维保模板列表
 */
export function getMaintainTemplateList(data) {
  return fetch({
    url: '/maintain/maintain/template/pageList',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 添加维保模板
 */
export function addTemplate(data) {
  return fetch({
    url: '/maintain/maintain/template/save',
    method: 'POST',
    data
  })
}



/**
 * @param {Object} data
 * 复制维保模板
 */
export function copyTemplate(data) {
  return fetch({
    url: '/maintain/maintain/template/copyTemplate',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 删除模版
 */
export function deleteTemplate(data) {
  return fetch({
    url: '/maintain/maintain/template/delete',
    method: 'POST',
    data
  })
}



/**
 * @param {Object} data
 * 导出模板
 */
export function exportTemplate(data) {
  return formAxios({
    url: '/maintain/maintain/template/export',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 获取部门列表
 */
export function getDepartmentTree(params) {
  return fetch({
    url: '/auth/department/getDepartmentTree',
    method: 'GET',
    params
  })
}


/**
 * @param {Object} data
 * 编辑部门
 */
export function editDepartment(data) {
  return fetch({
    url: '/auth/department/save',
    method: 'POST',
    data
  })
}



/**
 * @param {Object} data
 * 删除部门
 */
export function deleteDepartment(data) {
  return fetch({
    url: '/auth/department/delete',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 根据部门id获取项目
 */
export function getProjectIdByDepartment(data) {
  return fetch({
    url: '/auth/department/getProjectIdByDepartment',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 根据unitId和部门id获取项目
 */
export function getProjectLiftTree(params) {
  return fetch({
    url: '/maintain/project/projectLiftTree',
    method: 'GET',
    params
  })
}


/**
 * @param {Object} params
 * 根据部门id获取部门详情
 */
export function getDepartmentDetail(params) {
  return fetch({
    url: '/auth/department/detail',
    method: 'GET',
    params
  })
}




// WEBPACK FOOTER //
// ./src/api/MaintenanceTemplate/index.js